import type { SVGProps } from "react";

export function WasherDryingRackIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fill="currentColor"
        d="M4 22h16a1 1 0 0 0 1-1V5c0-1.654-1.346-3-3-3H6C4.346 2 3 3.346 3 5v16a1 1 0 0 0 1 1M18 3.924a1 1 0 1 1 0 2a1 1 0 0 1 0-2m-3 0a1 1 0 1 1 0 2a1 1 0 0 1 0-2M12 7c3.309 0 6 2.691 6 6s-2.691 6-6 6s-6-2.691-6-6s2.691-6 6-6"
      />
      <path
        fill="currentColor"
        d="M12.766 16.929c1.399-.261 2.571-1.315 3.023-2.665a3.85 3.85 0 0 0-.153-2.893a.48.48 0 0 0-.544-.266c-.604.149-1.019.448-1.5.801c-.786.577-1.765 1.294-3.592 1.294c-.813 0-1.45-.146-1.984-.354l-.013.009a4.006 4.006 0 0 0 4.763 4.074"
      />
    </svg>
  );
}
